module.exports = __webpack_public_path__ + "img/supplier2.c3eecbbf.png";